export enum AssessmentStatus {
  Draft = 0,
  InReview = 1,
  Cancelled = 2,
  Live = 3,
  Calculating = 4,
  Completed = 5
}

export enum DeliveryMethod {
  DeepLink = 'deeplink',
  Api = 'api',
  Manual = 'manual'
}

export interface SurveyBody {
  dashboardId?: string;
  gameName?: string;
  genres?: number[];
  ipBrands?: number[];
  audienceReach?: string;
  dau?: string;
  availableOnPlatforms?: number[];
  reward?: {
    rewardDescription?: string;
    rewardMechanism?: string;
    link?: string;
  };
  logoUrl?: string;
  customerNote?: string;
  status?: AssessmentStatus;
  assessmentType: '360';
}
export interface Assessment {
  id: string;
  createdAt: number;
  updatedAt: number;
  assessmentType: string;
  companyId: string;
  companyDetails?: {
    id: string;
    name: string;
  };
  dashboardDetails: {
    clustersCount: number;
    slug: string;
  };
  surveyId: string | null;
  dashboardId: string;
  gameName: string;
  genres: number[];
  ipBrands: number[];
  status: number;
  audienceReach: string;
  dau: string;
  availableOnPlatforms: number[];
  reward: {
    rewardDescription: string;
    rewardMechanism: DeliveryMethod;
    link: string;
  };
  customerNote: string;
  logoUrl: string;
  surveyLinks: {
    liveDeeplink?: DeeplinkBody;
    testDeeplink?: DeeplinkBody;
    liveIngestionApiKey: string;
    liveLink: string;
    liveSurveyId: number;
    testIngestionApiKey: string;
    testLink: string;
    testSurveyId: number;
  };
}
export interface DeeplinkBody {
  active: boolean;
  aesSecretKey: string;
  customTemplate: string;
  gameName: string;
  isStatic: boolean;
  link: string;
  surveyId: number;
}
